import { Navigate } from 'react-router-dom';

import { useAuth } from '../auth/AuthContext';
import { OPERATIONAL_UNIT_PATHS } from './types';

export function UnitLandingPage() {
  const { user } = useAuth();

  if (!user || user.unitCodes.length !== 1) {
    return <Navigate to="/enote" replace />;
  }

  return <Navigate to={OPERATIONAL_UNIT_PATHS[user.unitCodes[0]]} replace />;
}
